<template>
  <div class="skeleton-container">
    <div
      v-for="n in Math.max(line, 1)"
      :key="n"
      class="skeleton-line"
      :style="getStyle(n)"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "SkeletonLoader",
  props: {
    width: {
      type: [String, Number],
      default: "100%", // Mặc định là full-width
    },
    height: {
      type: [String, Number],
      default: "16px", // Chiều cao mặc định
    },
    line: {
      type: Number,
      default: 3, // Số dòng mặc định
    },
    color: {
      type: String,
      default: "", // Màu nền mặc định
    },
    mode: {
      type: String as PropType<"rectangle" | "circle">,
      default: "rectangle", // Mặc định là hình chữ nhật
    },
    style: {
      type: Object,
      default: {},
    },
  },
  methods: {
    getStyle(lineIndex: number) {
      const defaultColor = "#e0e0e0"; // Màu nền mặc định
      // const randomWidth =
      //   this.line > 1 && lineIndex === this.line ? "60%" : this.width;
      const randomWidth = this.width;
      return {
        width:
          this.mode === "circle"
            ? typeof this.height === "number"
              ? `${this.height}px`
              : this.height
            : typeof this.width === "number"
            ? `${randomWidth}px`
            : randomWidth,
        height:
          typeof this.height === "number" ? `${this.height}px` : this.height,
        backgroundColor: this.color || "",

        borderRadius: this.mode === "circle" ? "50%" : "4px",
        ...this.style,
      };
    },
  },
});
</script>